module.exports = __webpack_public_path__ + "img/Paladin-draenei-m-70.84e42824.gif";